// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * FavoritesSection Component CSS Module
 * Optimized for instant view switching performance
 */
.Z_PGSwdNiQGzrhQegsbZ {
  width: 100%;
  padding-bottom: 1rem;
}
.FU903j8YphYyHGyMrLDn {
  display: inline-block;
  height: 26px;
  width: 26px;
  vertical-align: middle;
}
`, "",{"version":3,"sources":["webpack://./src/features/favorites/components/FavoritesSection/FavoritesSection.module.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;EACE,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,sBAAsB;AACxB","sourcesContent":["/**\n * FavoritesSection Component CSS Module\n * Optimized for instant view switching performance\n */\n.emptyState {\n  width: 100%;\n  padding-bottom: 1rem;\n}\n.emptyImage {\n  display: inline-block;\n  height: 26px;\n  width: 26px;\n  vertical-align: middle;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"emptyState": `Z_PGSwdNiQGzrhQegsbZ`,
	"emptyImage": `FU903j8YphYyHGyMrLDn`
};
export default ___CSS_LOADER_EXPORT___;
